const Service = () => {
  const serviceList = [
    {
      img: "/images/service1.png",
      name: "누수탐지",
      txt2: "오래경험과 노하우 + 최신장비를 활용하여",
      txt3: "보다 높은 확률로 탐지해냅니다.",
      // link: "https://blog.naver.com/PostList.naver?blogId=rna0186&from=postList&categoryNo=24",
    },
    {
      img: "/images/service2.png",
      name: "누수공사",
      txt2: "누수의 근본적 원인이 되는 요소를 파악한 뒤",
      txt3: "누수의 원인을 해결하는 공사입니다.",
      // link: "https://blog.naver.com/PostList.naver?blogId=rna0186&from=postList&categoryNo=25",
    },
    {
      img: "/images/service3.png",
      name: "기타문의",
      txt2: "누수문제 외 방수 및 하수와 관련된 문제",
      txt3: "혹은 그 외의 공사문의도 환영입니다.",
      // link: "https://blog.naver.com/PostList.naver?blogId=rna0186&from=postList&categoryNo=28",
    },
  ];

  return (
    <div
      id="service"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20"
      >
        <h2 className="flex items-end justify-center gap-0.5 font-medium text-black">
          <img
            alt="logo"
            className="!relative w-auto h-full max-h-14 lg:max-h-24 py-1 object-contain cursor-pointer"
            src="/images/logo.png"
            width={531}
            height={65}
          />
          <span className="-mb-1.5 lg:-mb-2">서비스 목록</span>
        </h2>
        <p className="my-5 lg:text-lg">-&nbsp;서비스 목록&nbsp;-</p>
        <p className="lg:text-lg text-black">
          24시긴급출동누수에서&nbsp;제공해드리는 4가지&nbsp;고객약속!
        </p>
      </div>
      <div className="relative w-full h-fit max-w-[1300px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
        {serviceList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            className="relative w-full h-full mb-5"
          >
            <div className="relative w-full h-fit p-3 border rounded-3xl btn6 inline-block">
              <div className=" relative w-full h-fit my-3 2xl:my-5 text-center">
                <p className="gmedium text-2xl 2xl:text-3xl text-black mb-3">
                  {v.name}
                </p>
                <p className="text-font">{v.txt2}</p>
                <p className="text-font">{v.txt3}</p>
              </div>
              <div className="relative w-full h-fit rounded-3xl overflow-hidden">
                <img
                  className="!relative w-full h-full object-cover object-center transition-transform duration-300"
                  alt="img"
                  src={v.img}
                  width={611}
                  height={589}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
